import { render } from "./AuthContainer.vue?vue&type=template&id=165ee7c0&scoped=true"
import script from "./AuthContainer.vue?vue&type=script&lang=js"
export * from "./AuthContainer.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-165ee7c0"

export default script